import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const servicedeskSurveysRoute: InvariantJiraRoute = {
	path: '/jira/servicedesk/projects/:projectKey/surveys/:surveyId?/(edit|settings)?',
	name: 'servicedesk-surveys',
};
